import { createI18n } from "vue-i18n"

const i18n = createI18n({
  legacy: false,
  warnHtmlMessage: false,
})

export default function(app) {
  app.use(i18n)
}